<section
  class="traveller-stories-section"
  [ngClass]="{
    'd-none': !travelStories && travelStories.length == 0,
  }"
>
  <div class="container mb-3">
    <app-section-title
      [inital]="'Hotel’s'"
      [title]="'Guest Testimonials'"
      class="traveller-stories-title"
      [subtitle]="'Real Experiences. Real Words'"
      [iscursive]="true"
    ></app-section-title>

    <div class="d-flex justify-content-end align-items-center mb-3">
      <app-carousel-navigation
        [swiperInstance]="swiperInstance"
      ></app-carousel-navigation>
    </div>

    <!-- <app-carousel-navigation
      [swiperInstance]="swiperInstance"
    ></app-carousel-navigation> -->
  </div>

  <div class="container position-relative">
    <div class="row">
      <div class="col-md-12">
        <swiper-container
          #swiperContainer
          init="false"
          [slides-per-view]="3"
          [speed]="500"
          autoplay-delay="2000"
          [loop]="true"
          [navigation]="false"
          [space-between]="10"
          [free-mode]="true"
          class="swiper-3d"
          [breakpoints]="breakpoints"
        >
          @for (item of reviews; track item) {
            <swiper-slide
              class="swiper-slide-3d pb-4"
              (mouseenter)="pauseAutoplay()"
              (mouseleave)="resumeAutoplay()"
            >
              <app-diaries-card [reviews]="item"></app-diaries-card>
            </swiper-slide>
          }
        </swiper-container>
      </div>
    </div>
  </div>
</section>
